import { persistReducer } from 'redux-persist'
import * as types from '../actions/sync/auth/Constants'
import { GET_ACTIVE_ORGANIZATIONS_SUCCESS } from '../actions/sync/organizations/Constants'
import { GET_ACTIVE_TYPES_SUCCESS } from '../actions/sync/types/Constants'
import { GET_ACTIVE_ATTRIBUTES_SUCCESS } from '../actions/sync/attributes/Constants'
import {
  FULL_INFO_FAILURE,
  FULL_INFO_STARTED,
  FULL_INFO_SUCCESS,
  GET_DOMAIN_LOGIN_INFO_FAILURE,
  GET_DOMAIN_LOGIN_INFO_STARTED,
  GET_DOMAIN_LOGIN_INFO_SUCCESS,
  SET_CURRENT_DOMAIN,
  GET_GDPR_INFO_SUCCESS,
  GET_USER_DOMAINS_SUCCESS,
  GET_USER_DOMAINS_FAILURE,
} from '../actions/sync/domain/Constants'
import {
  APPROVED_REASONS_SUCCESS,
  CONFIG_SUCCESS,
  GET_NEW_IDEAS_SUCCESS,
  GET_TOTAL_INVESTMENTS_SUCCESS,
  REJECT_REASONS_SUCCESS,
} from '../services/TypesConstants'
import { GET_ACTIVE_GOALS_SUCCESS } from '../actions/sync/goals/Constants'
import { createPersistReducerConfig } from '../store/Persistence.Utils'
import { GET_VISIT_IDEA_SUCCESS } from '../actions/sync/ideas/ideasActionConstans'

export const initialState = {
  config: {
    defaultColors: {
      primary: '',
      secondary: '',
      headerText: '',
    },
    isOrganizationsActive: false,
    isTypesActive: false,
    isAttributesActive: false,
    organizationsName: '',
    useHelpSection: false,
  },
  currentDomain: '',
  lastDomainVisited: '',
  dataLoaded: false,
  dataLoading: false,
  failure: false,
  domain: {
    newIdeas: '0',
    totalInvestments: '0',
    desktopAccesses: 0,
    mobileAccesses: 0,
    iosAccesses: 0,
    androidAccesses: 0,
    implementedIdeas: 0,
    ideasVisits: 0,
    activeUsers: 0,
    publishedComments: 0,
    domainCreationDate: null,
  },
  domainConfiguration: {
    challengeProposal: false,
    logo: null,
    organizationsName: '',
    isOrganizationsActive: false,
    isTypesActive: false,
    isAttributesActive: false,
    isPreviousValidationEnabled: false,
    isLogisticActiveOnCreate: false,
    useHelpSection: false,
    contributeCurrencySymbol: '',
    logisticCurrencyConfiguration: {},
    contributeCurrencyConfiguration: {},
    hasCurrencyIconToLeft: true,
    currencyConfiguration: {},
    currencyIcon: 'nextcoin4',
    ideaStatusStepper: {
      approvedLabel: '',
      approvedColor: '',
      discardedLabel: '',
      discardedColor: '',
      implementedLabel: '',
      implementedColor: '',
      pendingSupportLabel: '',
      pendingSupportColor: '',
      pilotActiveLabel: '',
      pilotActiveColor: '',
      roundClosedLabel: '',
      roundClosedColor: '',
      supportedLabel: '',
      supportedColor: '',
    },
    splashConfiguration: {},
    isBudgetActive: false,
    isTimeActive: false,
    isOtherActive: false,
    isContributionActive: false,
    isPrivateFlowActive: false,
    privateBannerSrc: '',
    isChallengeMandatoryForIdeaCreation: false,
    isAnonymousIdeas: false,
    isAnonymousIdeasMandatory: false,
  },
  info: [],
  adminRole: true,
  goals: [],
  organizations: [],
  folderOrganizations: [],
  types: [],
  attributes: [],
  badges: [],
  nextinits: [],
  rejectedReasons: [],
  approvedReasons: [],
  infoPoints: [],
  isLoadedLoginInfo: false,
  loginInfo: {
    useCreateAccount: false,
    useCustomColor: false,
    useCustomTextColor: false,
    useCustomImg: false,
    useCustomText: false,
    useCustomBgImg: false,
    useCustomSubTitle: false,
    useCustomSubTitleWelcome: false,
    useCustomWelcome: false,
    customColor: '',
    customTextColor: '',
    customImg: '',
    customText: '',
    customBgImg: '',
    customSubTitle: '',
    customSubTitleWelcome: '',
    customWelcome: '',
    accessMedia: {
      Google: false,
    },
    customRrss: [],
    customAppStoreLinks: {
      androidUrl: '',
      iosUrl: '',
    },
  },
  gdpr: undefined,
  customTitlesConf: {
    customIdeaTitles: {
      singularTitle: '',
      pluralTitle: '',
    },
    isChallenge: true,
    isInvestment: true,
    isRanking: true,
  },
  userDomainList: [],
}

const domainReducer = (state = initialState, action) => {
  switch (action.type) {
    case REJECT_REASONS_SUCCESS:
      return {
        ...state,
        rejectedReasons: action.response,
      }
    case APPROVED_REASONS_SUCCESS:
      return {
        ...state,
        approvedReasons: action.response,
      }
    case CONFIG_SUCCESS:
      return {
        ...state,
        config: action.response,
      }
    case FULL_INFO_STARTED:
      return {
        ...state,
        dataLoading: true,
      }
    case FULL_INFO_SUCCESS:
      return {
        ...state,
        dataLoaded: true,
        dataLoading: false,
        failure: false,
        badges: action.response.badges,
        nextinits: action.response.nextinits,
        domain: {
          ...state.domain,
          newIdeas: action.response.domain.newIdeas,
          totalInvestments: action.response.domain.totalInvestments,
          desktopAccesses: action.response.domain.desktopAccesses,
          mobileAccesses: action.response.domain.mobileAccesses,
          iosAccesses: action.response.domain.iosAccesses,
          androidAccesses: action.response.domain.androidAccesses,
          createdIdeas: action.response.domain.createdIdeas,
          implementedIdeas: action.response.domain.implementedIdeas,
          ideasVisits: action.response.domain.ideasVisits,
          activeUsers: action.response.domain.activeUsers,
          investmentsMade: action.response.domain.investmentsMade,
          publishedComments: action.response.domain.publishedComments,
          domainCreationDate: action.response.domain.domainCreationDate,
        },
        domainConfiguration: {
          challengeProposal: action.response.domainConfiguration.challengeProposal,
          logo: action.response.domainConfiguration.logo,
          customFooterText: action.response.domainConfiguration.customFooterText,
          organizationsName: action.response.domainConfiguration.organizationsName,
          typesName: action.response.domainConfiguration.typesName,
          attributesName: action.response.domainConfiguration.attributesName,
          isOrganizationsActive: action.response.domainConfiguration.isOrganizationsActive,
          isTypesActive: action.response.domainConfiguration.isTypesActive,
          isAttributesActive: action.response.domainConfiguration.isAttributesActive,
          useHelpSection: action.response.domainConfiguration.useHelpSection,
          isPreviousValidationEnabled:
            action.response.domainConfiguration.isPreviousValidationEnabled,
          logisticCurrencyConfiguration:
            action.response.domainConfiguration.logisticCurrencyConfiguration,
          contributeCurrencyConfiguration:
            action.response.domainConfiguration.contributeCurrencyConfiguration,
          logistic: action.response.domainConfiguration.logistic,
          isLogisticActiveOnCreate: action.response.domainConfiguration.isLogisticActiveOnCreate,
          logisticCurrencySymbol: action.response.domainConfiguration.logisticCurrencySymbol,
          contributeCurrencySymbol: action.response.domainConfiguration.contributeCurrencySymbol,
          hasCurrencyIconToLeft: action.response.domainConfiguration.hasCurrencyIconToLeft,
          currencyConfiguration: action.response.domainConfiguration.currencyConfiguration,
          currencyIcon: action.response.domainConfiguration.currencyIcon,
          isBudgetActive: action.response.domainConfiguration.isBudgetActive,
          isTimeActive: action.response.domainConfiguration.isTimeActive,
          isOtherActive: action.response.domainConfiguration.isOtherActive,
          isContributionActive: action.response.domainConfiguration.isContributionActive,
          ideaStatusStepper: action.response.domainConfiguration.ideaStatusStepper,
          splashConfiguration: action.response.domainConfiguration.splashConfiguration,
          language: action.response.domainConfiguration.lang,
          isPrivateFlowActive: action.response.domainConfiguration.isPrivateFlowActive,
          privateBannerSrc: action.response.domainConfiguration.privateBannerSrc,
          isChallengeMandatoryForIdeaCreation:
            action.response.domainConfiguration.isChallengeMandatoryForIdeaCreation,
          isAnonymousIdeas: action.response.domainConfiguration.isAnonymousIdeas,
          isAnonymousIdeasMandatory: action.response.domainConfiguration.isAnonymousIdeasMandatory,
          legalAcceptTitle: action.response.domainConfiguration.legalAcceptTitle,
          legalAcceptHTML: action.response.domainConfiguration.legalAcceptHTML,
        },
        gdpr: action.response.gdpr,
        customTitlesConf: action.response.customTitlesConf,
      }
    case FULL_INFO_FAILURE:
      return {
        ...state,
        dataLoading: false,
        failure: true,
      }
    case types.POST_GOOGLE_LOGIN_SUCCESS:
    case types.PASSWORD_LOGIN_SUCCESS:
      return {
        ...state,
        info: action.response.domainInfo,
      }
    case SET_CURRENT_DOMAIN:
      return {
        ...state,
        currentDomain: action.domain,
      }
    case GET_ACTIVE_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.response.organizations,
        folderOrganizations: action.response.folderOrganizations,
      }
    case GET_ACTIVE_TYPES_SUCCESS:
      return {
        ...state,
        types: action.response.types,
      }
    case GET_ACTIVE_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        attributes: action.response.attributes,
      }
    case GET_ACTIVE_GOALS_SUCCESS:
      return {
        ...state,
        goals: action.response.goals,
      }
    case GET_DOMAIN_LOGIN_INFO_SUCCESS:
      return {
        ...state,
        loginInfo: action.response,
        isLoadedLoginInfo: true,
      }
    case GET_DOMAIN_LOGIN_INFO_STARTED:
      return {
        ...state,
        isLoadedLoginInfo: false,
      }
    case GET_DOMAIN_LOGIN_INFO_FAILURE:
      return {
        ...state,
        isLoadedLoginInfo: true,
        failure: true,
      }
    case types.PASSWORD_LOGOUT_SUCCESS:
    case types.SET_LOGGEDOUT:
      return {
        ...initialState,
        lastDomainVisited: state.currentDomain,
      }
    case GET_GDPR_INFO_SUCCESS:
      return {
        ...state,
        gdpr: action.response,
      }
    case GET_TOTAL_INVESTMENTS_SUCCESS:
      return {
        ...state,
        domain: {
          ...state.domain,
          totalInvestments: action.response.totalInvestments,
        },
      }
    case GET_NEW_IDEAS_SUCCESS:
      return {
        ...state,
        domain: {
          ...state.domain,
          newIdeas: action.response.newIdeas,
        },
      }
    case GET_VISIT_IDEA_SUCCESS:
      return {
        ...state,
        domain: {
          ...state.domain,
          ideasVisits: action.response.ideasVisits,
        },
      }
    case GET_USER_DOMAINS_SUCCESS:
      return {
        ...state,
        userDomainList: action.response,
      }
    case GET_USER_DOMAINS_FAILURE:
      return {
        ...state,
        userDomainList: [],
      }
    default:
      return state
  }
}

const persistDomainReducerConfig = createPersistReducerConfig('RootDomain', ['currentDomain'])

const persistDomainReducer = persistReducer(persistDomainReducerConfig, domainReducer)

export default persistDomainReducer
